export default __webpack_public_path__ + "assets/044372ed87710644a520462a7713257b.png";